var _circle, _circle2, _circle3, _path, _path2, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDollarsign(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 74,
    viewBox: "0 0 71 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 65.0518,
    cy: 67.8032,
    r: 5.64004,
    stroke: "#01033D",
    strokeWidth: 0.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.84131,
    cy: 3.94092,
    r: 3.71328,
    stroke: "#01033D",
    strokeWidth: 0.2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.3823,
    cy: 37.0166,
    r: 32,
    fill: "url(#paint0_linear_255_369)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.3823 19.087V54.9462",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5322 25.6069H28.3074C26.7944 25.6069 25.3433 26.2079 24.2735 27.2778C23.2036 28.3477 22.6025 29.7987 22.6025 31.3118C22.6025 32.8248 23.2036 34.2758 24.2735 35.3457C25.3433 36.4156 26.7944 37.0166 28.3074 37.0166H36.4573C37.9703 37.0166 39.4213 37.6177 40.4912 38.6876C41.5611 39.7574 42.1621 41.2085 42.1621 42.7215C42.1621 44.2346 41.5611 45.6856 40.4912 46.7555C39.4213 47.8254 37.9703 48.4264 36.4573 48.4264H22.6025",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.1117,
    y: 19.4746,
    width: 4.4618,
    height: 56.0092,
    rx: 2.2309,
    transform: "rotate(-48.3589 10.1117 19.4746)",
    fill: "white",
    stroke: "url(#paint1_linear_255_369)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_255_369",
    x1: -7.38301,
    y1: -10.7075,
    x2: 14.7284,
    y2: 61.318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#3AE0EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4CB3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_255_369",
    x1: 8.74306,
    y1: 5.50943,
    x2: 28.7079,
    y2: 11.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#3AE0EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4CB3FE"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarsign);
export default __webpack_public_path__ + "static/media/dollarsign.f3d4466d8788253be440cf0938a9250f.svg";
export { ForwardRef as ReactComponent };